import React from "react";
import TextInput from "./TextInput";

// import StyledCleave from "./StyledCleaveInput";
// require("cleave.js/dist/addons/cleave-phone.us");

export default function PhoneNumberInput({ regionCode = "US", ...rest }: any) {
  return (
    <TextInput type="email" center {...rest} />

    // <StyledCleave
    //   {...rest}
    //   center
    //   type="tel"
    //   options={{ phone: true, phoneRegionCode: regionCode }}
    // />
  );
}
